var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1308 7.131C10.0743 7.189 9.86094 7.437 9.6622 7.641C8.49708 8.924 5.45762 11.024 3.86678 11.665C3.62518 11.768 3.01437 11.986 2.68802 12C2.3753 12 2.0772 11.928 1.79274 11.782C1.43814 11.578 1.15368 11.257 0.997808 10.878C0.897467 10.615 0.741598 9.828 0.741598 9.814C0.585728 8.953 0.5 7.554 0.5 6.008C0.5 4.535 0.585728 3.193 0.713346 2.319C0.727959 2.305 0.883829 1.327 1.05431 0.992C1.36702 0.38 1.97784 0 2.63151 0H2.68802C3.11374 0.015 4.00901 0.395 4.00901 0.409C5.51413 1.051 8.48344 3.048 9.67681 4.375C9.67681 4.375 10.0129 4.716 10.159 4.929C10.387 5.235 10.5 5.614 10.5 5.993C10.5 6.416 10.3724 6.81 10.1308 7.131Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.570ef11d11af8301b3b7f6db58a8ac98.svg";
export { ForwardRef as ReactComponent };